import { Box, Button, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Portal, type PlacementWithLogical } from "@chakra-ui/react"
import React, { Fragment } from "react"
import ReactMarkdown from "react-markdown"

interface SnapPopoverInterface {
  text: string | string[]
  noteIcon?: React.ReactNode
  triggerText?: string
  placement?: PlacementWithLogical
  usePortal?: boolean
}

const RenderAnArrayOfNotes = ({ notes }: { notes: string[] }): React.ReactNode => (
  <Fragment>
    <Box display="grid" gridGap="2" gridRow="auto">
      {notes?.map((t, i) => (
        <Fragment key={i}>
          <Box>
            <ReactMarkdown>{t.toString() ?? "-"}</ReactMarkdown>
          </Box>
        </Fragment>
      ))}
    </Box>
  </Fragment>
)

export const SnapPopoverNotes = ({ text, triggerText = "Note", noteIcon, placement, usePortal }: SnapPopoverInterface): React.ReactNode => {
  const filterValidNotes = (t: string): boolean => {
    return Boolean(t) && t?.length > 0
  }
  const validNotes = Array.isArray(text) ? text.filter(t => filterValidNotes(t)) : text

  const content = (
    <PopoverContent zIndex={usePortal ? 1400 : undefined}>
      <PopoverArrow />
      <PopoverBody>
        {Array.isArray(validNotes) ? <RenderAnArrayOfNotes notes={validNotes} /> : <ReactMarkdown>{validNotes?.toString()}</ReactMarkdown>}
      </PopoverBody>
    </PopoverContent>
  )

  return (
    <>
      <Popover trigger="hover" placement={placement} isLazy>
        <PopoverTrigger>
          <Button opacity={validNotes?.length ? "1" : "0.4"} variant="linkButton" minW={"10px"}>
            {noteIcon ?? triggerText}
          </Button>
        </PopoverTrigger>
        {usePortal ? <Portal>{content}</Portal> : content}
      </Popover>
    </>
  )
}
